import { AffiliateApi } from '@api';
import { affiliateTypes as actionTypes } from './types';

export const fetchAffiliates = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.LIST.LOADING,
  });

  AffiliateApi.getList(params)
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.SUCCESS,
        payload: response,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};

export const fetchRecentAffiliates = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.LIST_RECENT.LOADING,
  });

  AffiliateApi.getRecent(params)
    .then((response) => {
      dispatch({
        type: actionTypes.LIST_RECENT.SUCCESS,
        payload: response,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST_RECENT.FAILURE,
        message: error.statusText,
      });
    });
};

export const searchAffiliates = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.SEARCH.LOADING,
  });

  const searchKey = JSON.stringify(params);

  AffiliateApi.search(params)
    .then((response) => {
      dispatch({
        type: actionTypes.SEARCH.SUCCESS,
        payload: { ...response, data: { [searchKey]: response.data } },
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.SEARCH.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};

export const marketSearchAffiliates = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.MARKET_SEARCH.LOADING,
  });
  const stateKey = JSON.stringify(params);

  AffiliateApi.getMarketSearch(params)
    .then((response) => {
      dispatch({
        type: actionTypes.MARKET_SEARCH.SUCCESS,
        payload: {
          ...response,
          stateKey,
        },
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.MARKET_SEARCH.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};
